export const environment = {
  production: true,
  appConfigUrl: 'assets/config/app.config.json',
  customNavigationDocument: 'assets/navigation/navigation.json',
};
